import { createBrowserRouter, RouterProvider } from "react-router-dom";

import Home from "./Home";
import Solucoes from "./Solucoes";
import Sobre from "./Sobre";
import Parceiros from "./Parceiros";
import Contatenos from "./Contatenos";
import { Portal } from "./Portal";
import AppLayout from "./AppLayout";
import Signin from "./Portal/Signin";
import Signup from "./Portal/Signup";
import PortalHome from "./Portal/PortalHome";
import ShapeManager from "./Portal/ShapeManager";
import Trabalhos from "./Portal/Trabalhos";
import Implementos from "./Portal/Implementos";
import Veiculos from "./Portal/Veiculos";
import Verificacao from "./Portal/Verificacao";
import ShapeDetalhe from "./Portal/ShapeDetalhe";
import TrabalhoDetalhe from "./Portal/TrabalhoDetalhe";
import ImplementoDetalhe from "./Portal/ImplementoDetalhe";
import VeiculoDetalhe from "./Portal/VeiculoDetalhe";

const router = createBrowserRouter([
  { element: <AppLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/solucoes", element: <Solucoes /> },
      { path: "/sobre", element: <Sobre /> },
      { path: "/parceiros", element: <Parceiros /> },
      { path: "/contato", element: <Contatenos /> },
      { path: "/portal", element: <Portal />, children: [
      { path: "/portal/signin", element: <Signin /> },
      { path: "/portal/signup", element: <Signup /> },
      { path: "/portal/home", element: <PortalHome /> },
      { path: "/portal/mapas", element: <ShapeManager />}, 
      { path: "/portal/mapas-detalhe", element: <ShapeDetalhe />},
      { path: "/portal/trabalhos", element: <Trabalhos /> },
      { path: "/portal/trabalho-detalhe", element: <TrabalhoDetalhe />},
      { path: "/portal/implementos", element: <Implementos /> },
      { path: "/portal/implemento-detalhe", element: <ImplementoDetalhe /> },
      { path: "/portal/veiculos", element: <Veiculos /> },
      { path: "/portal/veiculo-detalhe", element: <VeiculoDetalhe /> },
      { path: "/portal/verificacao", element: <Verificacao /> }
      ] },
    ]
  }
  
]);

function App() {
  return (
    <RouterProvider router={router} />
  )
   
}

export default App;
